export default __webpack_public_path__ + "static/media/jekos.67ed89e2.png";